import { Column, ColumnFormat } from '../../components/Table/Table';

export const Columns = (t): Column[] => [
    { id: 'netId', label: t('Master-data.hierarchy.detail.production.zone.table-2-col-1') },
    { id: 'userName', label: t('Master-data.hierarchy.detail.production.zone.table-2-col-2') },
    { id: 'taskResponsible', label: t('Master-data.hierarchy.detail.production.zone.table-2-col-3') },
];
